import React from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import { Container, Col, Row } from 'reactstrap';
import moment from 'moment';
import Loading from '../App/Loading';
import Link from 'react-router-dom/Link';
import NotificationSystem from 'rc-notification';
import Swal from 'sweetalert2';
import '../../scss/containers/welcome.scss';

class Welcome extends React.Component {
  state = {};

  componentDidMount() {
    const {
      authentication: { user },
    } = this.props;
    let endpoint = `data/guest/invite-background`;

    axios
      .post(`${process.env.REACT_APP_BOTTL_API_ENDPOINT_V2}/${endpoint}`, {
        id: user.id,
        token: user.token,
        passphrase: user.passphrase,
      })
      .then((res) => {});
  }

  render() {
    return (
      <Container className="dashboard as-welcome-finder">
        <h3 className="as-welcome-title">Bienvenue dans votre équipe Data</h3>
        <p>
          À partir de maintenant, vous avez accès au moteur de recherche, aux
          inmails, et à la gestion de votre abonnement sur Data
        </p>
        <a
          href={`${process.env.REACT_APP_BOTTL_WEBROOT}/caves/rechercher/`}
          type="button"
          target="_blank"
          className="btn btn-primary"
        >
          Accéder au moteur de recherche
        </a>
        <div className="sub-links">
          <a href="/_data/dashboards">Gérer mes dashboards</a>
          <a href="/_data/indicators">Gérer mes indicateurs</a>
        </div>
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  ...state,
});
export default connect(mapStateToProps)(Welcome);
